module.exports = __webpack_public_path__ + "static/media/clothing.74f3da86.svg";